import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var radioButtonWrapper = /*#__PURE__*/css(["display:flex;margin:", ";cursor:pointer;color:var(--neutral-black-base);", ""], stack(spacing.lg), mediaQuery({
  min: minBreakpoints.L
}, css(["margin:", ";"], stack(spacing.sm))));
export var radioButtonWrapperDisabled = /*#__PURE__*/css(["cursor:default;color:var(--neutral-black-40);"]);
export var radioButtonLabelText = /*#__PURE__*/css(["flex-grow:1;margin:", " 0 0 ", ";", ";"], pxToRem(spacing.base), pxToRem(spacing.xs), fontSize(text.BODY.MD));